var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecruitCounsillor2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 58,
    viewBox: "0 0 111 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_22765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83 5C97.3594 5 109 16.6407 109 31C109 45.3594 97.3594 57 83 57C68.6406 57 57 45.3594 57 31C57 16.6407 68.6406 5 83 5Z",
    stroke: "#1A1A18",
    strokeWidth: 2.6664,
    strokeMiterlimit: 22.9256,
    strokeDasharray: "13.33 13.33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.1171 41.7299C91.603 41.7299 98.4821 43.163 98.4821 44.931C98.4821 46.6988 91.603 48.132 83.1171 48.132C74.6314 48.132 67.7522 46.6988 67.7522 44.931C67.7522 43.163 74.6314 41.7299 83.1171 41.7299Z",
    fill: "#D9DADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1171 41.7299C91.603 41.7299 98.4821 43.163 98.4821 44.931C98.4821 46.6988 91.603 48.132 83.1171 48.132C74.6314 48.132 67.7522 46.6988 67.7522 44.931C67.7522 43.163 74.6314 41.7299 83.1171 41.7299Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4321 23.0227H98.2131V45.5706H67.4321V23.0227Z",
    fill: "#D9DADA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.823 19.6639C91.3088 19.6639 98.1879 21.0971 98.1879 22.8651C98.1879 24.6328 91.3088 26.066 82.823 26.066C74.3372 26.066 67.4585 24.6328 67.4585 22.8651C67.4585 21.0971 74.3372 19.6639 82.823 19.6639Z",
    fill: "#D9DADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.823 19.6639C91.3088 19.6639 98.1879 21.0971 98.1879 22.8651C98.1879 24.6328 91.3088 26.066 82.823 26.066C74.3372 26.066 67.4585 24.6328 67.4585 22.8651C67.4585 21.0971 74.3372 19.6639 82.823 19.6639Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1211 19L30.6815 22.5786L37.2424 26.1569L30.6814 30.2358L24.1814 33.7358L17.5605 29.7358L11 26L17.5605 22.5786L24.1211 19Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5404 40.6996L11.3606 33.468L11.1814 26.2358L17.6814 29.7358L24.1812 33.7358V40.7358V48.2358L17.8609 44.4677L11.5404 40.6996Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1814 33.7358L30.8609 30.0039L37.1814 26.2358L37.0018 33.4681L36.8224 40.7001L30.5019 44.4677L24.1814 48.2358V41.2358V33.7358Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0607 34.0607C66.6464 33.4749 66.6464 32.5251 66.0607 31.9393L56.5147 22.3934C55.9289 21.8076 54.9792 21.8076 54.3934 22.3934C53.8076 22.9792 53.8076 23.9289 54.3934 24.5147L62.8787 33L54.3934 41.4853C53.8076 42.0711 53.8076 43.0208 54.3934 43.6066C54.9792 44.1924 55.9289 44.1924 56.5147 43.6066L66.0607 34.0607ZM40 34.5H65V31.5H40V34.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_22765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1122.52,
    height: 1587.4,
    fill: "white",
    transform: "translate(-366 -243)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitCounsillor2);
export default __webpack_public_path__ + "static/media/recruit_counsillor2.e5e738e90a17216e9d4729fa412f0e94.svg";
export { ForwardRef as ReactComponent };